
import Vue from "vue";
import store from "@/store";
import { LOYALTY } from "@/store/loyalty";
import { mapState } from "vuex";
import { IRootState } from "@/store/types";
import { formatDate } from "@/helpers/date";
import { subMonths } from "date-fns";
import { LoyaltySchemeType } from "../../store/loyalty/types";

const currentMonth = new Date();

export default Vue.extend({
  props: {
    accountNumber: {}
  },
  data() {
    return {
      isLoading: false,
      dateFilter: currentMonth,
      pagination: {
        sortBy: "transactionDate"
      },
      headers: [
        { text: "Transaction date", value: "transactionDate" },
        { text: "Location", value: "locationName" },
        { text: "Card number name", value: "cardNumber" },
        { text: "Loyalty number", value: "membershipNumber" },
        { text: "Product Name", value: "productName" },
        { text: "Quantity", value: "quantity", sortable: false },
        { text: "Multiplier", value: "multiplier", sortable: false },
        { text: "Airpoints dollars", value: "points", sortable: false },
        { text: "Fly Buys points", value: "points", sortable: false }
      ],
      flybuysScheme: LoyaltySchemeType.FlyBuys,
      airpointsScheme: LoyaltySchemeType.Airpoints
    };
  },
  computed: {
    ...mapState({
      transactionList: (state: IRootState) =>
        state.loyalty.customerTransactionList
    }),
    formattedDate() {
      return formatDate(this.dateFilter, "MMMM YYYY");
    },
    airpointsTotal() {
      return this.transactionList
        ? this.transactionList
            .filter(
              (item: any) => item.loyaltyScheme === LoyaltySchemeType.Airpoints
            )
            .reduce(
              (total: any, transaction: any) =>
                Number(total) + Number(transaction.pointsAllocated),
              0
            ) || 0
        : 0;
    },
    flybuysTotal() {
      return this.transactionList
        ? this.transactionList
            .filter(
              (item: any) => item.loyaltyScheme === LoyaltySchemeType.FlyBuys
            )
            .reduce(
              (total: any, transaction: any) =>
                Number(total) + Number(transaction.pointsAllocated),
              0
            ) || 0
        : 0;
    },
    dateList() {
      const dates = [
        currentMonth,
        subMonths(currentMonth, 1),
        subMonths(currentMonth, 2),
        subMonths(currentMonth, 3)
      ];

      return dates.map(date => {
        return {
          text: formatDate(date, "MMMM YYYY"),
          value: date
        };
      });
    }
  },
  async mounted() {
    await this.onSearch();
  },
  methods: {
    async onSearch() {
      this.isLoading = true;

      await this.$store.dispatch(
        LOYALTY.NS(LOYALTY.ACTIONS.LOAD_CUSTOMER_TRANSACTIONS),
        {
          month: this.dateFilter && this.dateFilter.getMonth() + 1,
          year: this.dateFilter && this.dateFilter.getFullYear(),
          accountNumber: this.accountNumber
        }
      );

      this.isLoading = false;
    }
  }
});
